import { createRouter, createWebHistory } from 'vue-router'
import { dictionaryLabel,dictionaryState,loadBusinessDictionary } from '@/utils/businessDictionary'
import { captureWorkspaceScroll, navigationTarget } from '@/composables/workspace/tabState'
import HomeView from '../views/HomeView.vue'
import JsonTools from '../views/JsonToolstView.vue'
import AiImageView from '../views/AiImageView.vue'
import ImageGallery from '../views/ImageGallery.vue'
import LoginView from '../views/LoginView.vue'
import TransactionView from '../views/TransactionView.vue'
import TransactionCategoryView from '../views/TransactionCategoryView.vue'
import PricingView from '../views/PricingView.vue'
import FbaLabelView from '../views/FbaLabelView.vue'
import LabelOrganizeView from '../views/LabelOrganizeView.vue'
import InvoiceExportView from '../views/InvoiceExportView.vue'
import PdfToolsView from '../views/PdfToolsView.vue'
import AmazonShipmentView from '../views/AmazonShipmentView.vue'
import AmazonInventoryView from '../views/AmazonInventoryView.vue'
import AmazonOrderView from '../views/AmazonOrderView.vue'
import AmazonListingView from '../views/AmazonListingView.vue'
import SupplierView from '../views/SupplierView.vue'
import PurchaseOrderView from '../views/PurchaseOrderView.vue'
import ProductView from '../views/ProductView.vue'
import CategoryView from '../views/CategoryView.vue'
import LogisticsProviderView from '../views/LogisticsProviderView.vue'
import LogisticsWaybillView from '../views/LogisticsWaybillView.vue'
import ShopView from '../views/ShopView.vue'
import ProductBoardView from '../views/ProductBoardView.vue'
import ReportView from '../views/ReportView.vue'
import AdvertisingReportView from '../views/AdvertisingReportView.vue'
import SkuSalesReportView from '../views/SkuSalesReportView.vue'
import FbaStorageFeesView from '../views/FbaStorageFeesView.vue'
import ProfileView from '../views/ProfileView.vue'
import ForbiddenView from '../views/ForbiddenView.vue'
import SystemPermissionsView from '../views/SystemPermissionsView.vue'
import CompanyView from '../views/CompanyView.vue'
import { isAuthenticated, getUserPermissions, findPermissionCodeByPath } from '@/services/api.js'

const CronTasksView = () => import('../views/CronTasksView.vue')

const routes = [
  {
    path: '/daily-reports',
    name: 'DailyReports',
    component: () => import('../views/DailyReportsView.vue'),
    meta: { title: '运营日报', componentName: 'DailyReportsView' }
  },
  {
    path: '/amazon-listing-assignments',
    name: 'AmazonListingAssignments',
    component: () => import('../views/ListingAssignmentView.vue'),
    meta: { title: 'Listing 负责人分配', componentName: 'ListingAssignmentView' }
  },
  {
    path: '/performance',
    name: 'Performance',
    component: () => import('../views/PerformanceView.vue'),
    meta: { title: '人员绩效', componentName: 'PerformanceView', tabPolicy:{evictable:true} }
  },
  {
    path: '/',
    name: 'Home',
    component: CompanyView,
    meta: { title: '公司主页', componentName: 'CompanyView' }
  },
  {
    path: '/fanyi',
    name: 'Fanyi',
    component: HomeView,
    meta: { title: '翻译', componentName: 'app' }
  },
  {
    path: '/company',
    name: 'Company',
    component: CompanyView,
    meta: { title: '公司主页', componentName: 'CompanyView' }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { title: '登录', componentName: 'LoginView' }
  },
  {
    path: '/json',
    name: 'JsonTools',
    component: JsonTools,
    meta: { title: 'JSON工具', componentName: 'app' }
  },
  {
    path: '/ai-image',
    name: 'AiImage',
    component: AiImageView,
    meta: { title: 'AI图片', componentName: 'AiImageView' }
  },
  {
    path: '/gallery',
    name: 'ImageGallery',
    component: ImageGallery,
    meta: { title: '图片库', componentName: 'ImageGalleryView' }
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: TransactionView,
    meta: { title: '收支记账', componentName: 'TransactionView' }
  },
  {
    path: '/transaction-categories',
    name: 'TransactionCategories',
    component: TransactionCategoryView,
    meta: { title: '账目类别管理', componentName: 'TransactionCategoryView' }
  },
  {
    path: '/expense',
    redirect: '/transactions'
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: PricingView,
    meta: { title: '计算售价', componentName: 'PricingView' }
  },
  {
    path: '/fba-label',
    name: 'FbaLabel',
    component: FbaLabelView,
    meta: { title: 'FBA标签', componentName: 'FbaLabelView' }
  },
  {
    path: '/label-organize',
    name: 'LabelOrganize',
    component: LabelOrganizeView,
    meta: { title: '箱唛助手', componentName: 'LabelOrganizeView' }
  },
  {
    path: '/invoice-export',
    name: 'InvoiceExport',
    component: InvoiceExportView,
    meta: { title: '发票导出', componentName: 'InvoiceExportView' }
  },
  {
    path: '/pdf-tools',
    name: 'PdfTools',
    component: PdfToolsView,
    meta: { title: 'PDF工具', componentName: 'PdfToolsView' }
  },
  {
    path: '/amazon-shipments',
    name: 'AmazonShipments',
    component: AmazonShipmentView,
    meta: { title: '货件列表', componentName: 'AmazonShipmentView' }
  },
  {
    path: '/amazon-inventory',
    name: 'AmazonInventory',
    component: AmazonInventoryView,
    meta: { title: '库存列表', componentName: 'AmazonInventoryView' }
  },
  {
    path: '/amazon-orders',
    name: 'AmazonOrders',
    component: AmazonOrderView,
    meta: { title: '订单列表', componentName: 'AmazonOrderView' }
  },
  {
    path: '/amazon-listings',
    name: 'AmazonListings',
    component: AmazonListingView,
    meta: { title: 'Listing列表', componentName: 'AmazonListingView' }
  },
  {
    path: '/suppliers',
    name: 'Suppliers',
    component: SupplierView,
    meta: { title: '供应商管理', componentName: 'SupplierView' }
  },
  {
    path: '/purchase-orders',
    name: 'PurchaseOrders',
    component: PurchaseOrderView,
    meta: { title: '进货单管理', componentName: 'PurchaseOrderView' }
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductView,
    meta: { title: '产品维护', componentName: 'ProductView' }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: CategoryView,
    meta: { title: '类目维护', componentName: 'CategoryView' }
  },
  {
    path: '/logistics-providers',
    name: 'LogisticsProviders',
    component: LogisticsProviderView,
    meta: { title: '货代管理', componentName: 'LogisticsProviderView' }
  },
  {
    path: '/logistics-waybills',
    name: 'LogisticsWaybills',
    component: LogisticsWaybillView,
    meta: { title: '货代运单管理', componentName: 'LogisticsWaybillView' }
  },
  {
    path: '/shops',
    name: 'Shops',
    component: ShopView,
    meta: { title: '店铺管理', componentName: 'ShopView' }
  },
  {
    path: '/product-board',
    name: 'ProductBoard',
    component: ProductBoardView,
    meta: { title: '备货看板', componentName: 'ProductBoardView' }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: ReportView,
    meta: { title: '店铺报表', componentName: 'ReportView' }
  },
  {
    path: '/reports/sku-sales',
    name: 'SkuSalesReports',
    component: SkuSalesReportView,
    meta: { title: 'SKU销售报表', componentName: 'SkuSalesReportView' }
  },
  {
    path: '/reports/advertising',
    name: 'AdvertisingReports',
    component: AdvertisingReportView,
    meta: { title: '广告报表', componentName: 'AdvertisingReportView' }
  },
  {
    path: '/reports/fba-storage-fees',
    name: 'FbaStorageFeesReports',
    component: FbaStorageFeesView,
    meta: { title: 'FBA仓储费报表', componentName: 'FbaStorageFeesView' }
  },
  {
    path: '/cpc',
    redirect: '/cpc/campaigns'
  },
  {
    path: '/cpc/campaigns',
    name: 'CpcCampaigns',
    component: () => import('../views/cpc/CampaignList.vue'),
    meta: { title: 'CPC广告活动', componentName: 'CpcCampaigns', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/cpc/campaigns/:id/detail',
    name: 'CpcCampaignDetail',
    component: () => import('../views/cpc/CampaignDetail.vue'),
    meta: { title: 'CPC广告活动详情', componentName: 'CpcCampaignDetail', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/cpc/campaigns/create',
    name: 'CpcCreateCampaign',
    component: () => import('../views/cpc/CreateCampaign.vue'),
    meta: { title: '创建广告活动', componentName: 'CpcCreateCampaign', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/cpc/campaigns/:id/create-group',
    name: 'CpcCreateGroup',
    component: () => import('../views/cpc/CreateGroup.vue'),
    meta: { title: '添加广告组', componentName: 'CpcCreateGroup', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/cpc/campaigns/:id/groups/:adGroupId',
    name: 'CpcGroupDetail',
    component: () => import('../views/cpc/GroupDetail.vue'),
    meta: { title: 'CPC广告组详情', componentName: 'CpcGroupDetail', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/cpc/days/:type/:id',
    name: 'CpcDailyData',
    component: () => import('../views/cpc/DailyData.vue'),
    meta: { title: 'CPC分日数据', componentName: 'CpcDailyData', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/cpc/days/summary',
    name: 'CpcDailyDataSummary',
    component: () => import('../views/cpc/DailyData.vue'),
    meta: { title: 'CPC汇总分日数据', componentName: 'CpcDailyDataSummary', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/cpc/structure',
    name: 'CpcStructure',
    component: () => import('../views/cpc/CpcStructure.vue'),
    meta: { title: 'CPC广告结构', componentName: 'CpcStructure', tabPolicy:{group:'cpc'} }
  },
  {
    path: '/system/cron-tasks',
    name: 'CronTasks',
    component: CronTasksView,
    meta: { title: '计划任务', componentName: 'CronTasksView' }
  },
  {
    path: '/system/permissions',
    name: 'SystemPermissions',
    component: SystemPermissionsView,
    meta: { title: '权限管理', componentName: 'SystemPermissionsView' }
  },
  {
    path: '/system/sellersprite',
    name: 'SellerspriteConfig',
    component: () => import('../views/SellerspriteConfigView.vue'),
    meta: { title: '卖家精灵ASIN配置', componentName: 'SellerspriteConfigView' }
  },
  {path:'/ai/chat',name:'AiChat',component:()=>import('../views/ai/AiChatView.vue'),meta:{title:'AI对话',componentName:'AiChatView',aiPermission:'ai_chat:use'}},
  {
    path: '/ai/operations',
    alias: '/tools/ai-operations',
    name: 'AiOperations',
    component: () => import('../views/ai/AiOperationsView.vue'),
      meta: { title: 'AI托管 · ASIN列表', componentName: 'AiOperationsView', aiPermission:'ai_operations:manage' }
  },
  {
    path: '/ai/prompts',
    alias: '/tools/ai-operations/prompts',
    name: 'AiPromptManagement',
    component: () => import('../views/ai/AiPromptManagement.vue'),
    meta: { title: 'AI · 提示词管理', componentName: 'AiPromptManagement', aiPermission:'ai_prompts:manage' }
  },
  {
    path: '/ai/tools',
    alias: '/tools/ai-operations/tools',
    name: 'AiToolManagement',
    component: () => import('../views/ai/AiToolManagement.vue'),
    meta: { title: 'AI · 工具管理', componentName: 'AiToolManagement', aiPermission:'ai_tools:manage' }
  },
  {
    path: '/ai/tools/:toolName/preview',
    alias: '/tools/ai-operations/tools/:toolName/preview',
    name: 'AiToolPreview',
    component: () => import('../views/ai/AiToolPreview.vue'),
    props: true,
    meta: { title: 'AI工具 · 数据预览', componentName: 'AiToolPreview', aiPermission:'ai_tools:manage', tabPolicy:{evictable:true} },
    // 工具代码只定位白名单工具，Nav页签名称使用共享字典的中文名称。
    beforeEnter(to){to.meta.title='AI工具 · '+dictionaryLabel('ai.tool',to.params.toolName,'数据预览')}
  },
  {
    path: '/tools/keyword-reverse',
    name: 'KeywordReverse',
    component: () => import('../views/KeywordReverseView.vue'),
    meta: { title: '关键词反查', componentName: 'KeywordReverseView', tabPolicy:{evictable:true} }
  },
  {
    path: '/tools/competitor-data',
    name: 'CompetitorData',
    component: () => import('../views/CompetitorDataView.vue'),
    meta: { title: '竞品数据', componentName: 'CompetitorDataView', tabPolicy:{evictable:true} }
  },
  {
    path: '/system/ui-config',
    name: 'UiConfig',
    component: () => import('../views/UiConfigView.vue'),
    meta: { title: '界面配置', componentName: 'UiConfigView' }
  },
  {
    path: '/system/business-dictionary',
    name: 'BusinessDictionary',
    component: () => import('../views/BusinessDictionaryView.vue'),
    meta: { title: '业务字典', componentName: 'BusinessDictionaryView' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView,
    meta: { title: '个人中心', componentName: 'ProfileView' }
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: ForbiddenView,
    meta: { title: '无权限', componentName: 'ForbiddenView' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局前置守卫
const publicPaths = ['/', '/json', '/login', '/403', '/company', '/fanyi']

router.beforeEach(async (to, from, next) => {
  captureWorkspaceScroll()
  navigationTarget.value=to.fullPath
  // 首次准备名称快照；已有快照或失败提示时后台更新，慢字典不阻塞页签切换。
  if (isAuthenticated()) {
    const refreshDictionary = loadBusinessDictionary()
    if (!dictionaryState.ready && !dictionaryState.warning) await refreshDictionary
  }
  // 1. 未登录检查
  if (!publicPaths.includes(to.path) && !isAuthenticated()) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  // 2. 权限检查（从 /api/menus 缓存中动态查找 permission_code）
  if (to.meta.aiPermission && !getUserPermissions().includes(to.meta.aiPermission)) {
    return next('/403')
  }
  if (to.path === '/tools/competitor-data' && !getUserPermissions().includes('competitor_data:view')) {
    return next('/403')
  }
  if (to.path === '/tools/keyword-reverse' && !getUserPermissions().includes('keyword_data:view')) {
    return next('/403')
  }
  if (to.path === '/system/sellersprite' && !getUserPermissions().includes('system:sellersprite_config')) {
    return next('/403')
  }
  if (['/system/ui-config','/system/business-dictionary'].includes(to.path) && !getUserPermissions().includes('system:ui_config')) {
    return next('/403')
  }
  if (to.path === '/daily-reports' && !getUserPermissions().includes('daily_reports:view')) {
    return next('/403')
  }
  if (to.path === '/amazon-listing-assignments' && !getUserPermissions().includes('amazon_listings:assign')) {
    return next('/403')
  }
  if (to.path === '/performance' && !getUserPermissions().some(code => ['performance:view_self', 'performance:view_all'].includes(code))) {
    next('/403')
    return
  }
  if (isAuthenticated()) {
    const needed = findPermissionCodeByPath(to.path)
    if (needed) {
      const permissions = getUserPermissions()
      if (permissions.length > 0 && !permissions.includes(needed)) {
        next('/403')
        return
      }
    }
  }

  next()
})

router.afterEach(to=>{if(navigationTarget.value===to.fullPath)navigationTarget.value=''})
router.onError(()=>{navigationTarget.value=''})
export default router
